import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { Message } from 'primeng/components/common/api';
import { ConfirmationService } from "primeng/components/common/confirmationservice";
import { DataTable, SelectItem } from 'primeng/primeng';
import { LazyLoadEvent } from '../../models/DataTables/lazyLoadEvent';
import { ChangePasswordUserModel } from "../../models/inModels/ChangePasswordModel";
import { SendMessageToUserModel } from "../../models/inModels/MessageModel";
import { CreateTeamForUserModel } from "../../models/inModels/Team";
import { User } from '../../models/outModels/User';
import { AuthenticationService } from "../../services/authentication/authentication.service";
import { StorageService } from "../../services/system/storage.service";
import { UserService } from '../../services/user/user.service';
import { TeamsService } from "../../services/teams/team.service";

@Component({
	selector: 'app-users',
	templateUrl: './users.component.html',
	styleUrls: ['./users.component.css']
})
export class UsersComponent {
	loading: boolean;
	loadingDialog: boolean;
	// Table data
	users: User[];
	error: Message[];
	errorDialog: Message[];
	// Total number of records
	totalRecords: number;
	filteredRecords: number;
	// Event to filter on row change
	rowEvent: LazyLoadEvent;
	rows: SelectItem[];
	selectedRows: number;
	sendUserModel: SendMessageToUserModel;
	sendUserDialog = false;
	selectedUser: User;
	sending = false;
	roles;
	birthdays = false;
	uploading = false;
	importUrl: string;
	// subscription plan id query param
	subscriptionPlanId: number;
	subscriptionValid?: boolean;
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private userService: UserService,
		private confirmationService: ConfirmationService,
		private auth: AuthenticationService,
		public storageService: StorageService,
		private teamService: TeamsService) {
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
		this.sendUserModel = new SendMessageToUserModel();
		this.importUrl = userService.importUrl;
		this.subscriptionPlanId = this.route.snapshot.queryParams.subscriptionPlanId
		this.subscriptionValid = this.route.snapshot.queryParams.subscriptionValid
	}

	changeRows(event) {
		this.loadUsersLazy(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		this.birthdays = false;
		gb.value = '';
		dt.reset();
	}

	loadUsersLazy(event) {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.userService.getUsers(event, this.birthdays, this.subscriptionPlanId, this.subscriptionValid).then(
			dataPager => {
				this.users = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;

				console.log(this.users)
			},
			error => {
				this.loading = false;
				this.users = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	edit(user: User) {
		this.router.navigate(['users/edit', user.Id]);
	}

	businessProfile(user: User) {
		this.router.navigate(['users/business/profile', user.Id]);
	}


	managePassword(user: User) {
		//window.open('change-password/' + user.Id);
		this.router.navigate(['change-password', user.Id]);
	}

	sendDialogOpen(user: User) {
		this.selectedUser = user;
		this.sendUserModel.UserId = user.Id;
		this.sendUserDialog = true;
	}

	sendUser() {
		this.sending = true;
		console.log(this.sendUserModel);
		this.userService.sendMessageToUser(this.sendUserModel).then(
			result => {
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: `Message Sent to ${this.selectedUser.UserName}.` });
				this.sending = false;
				this.sendUserDialog = false;
				this.sendUserModel.Subject = "";
				this.sendUserModel.Message = "";
			},
			error => {
				this.sending = false;
				this.errorDialog = [];
				this.errorDialog.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}


	confirmDelete(user: User, dt: DataTable) {
		this.confirmationService.confirm({
			message: `Are you sure you want to delete <strong>${user.UserName}</strong>? <br/> Deleting this user will prevent them from logging in to the platform.`,
			header: 'Delete Confirmation',
			icon: 'fa fa-trash',
			acceptLabel: "yes",
			rejectLabel: "no",
			accept: () => {
				this.loading = true;
				this.userService.delete(user.Id).then(
					success => {
						dt.reset();
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					}
				);
			}
		});
	}

	confirmLoginDetails(user: User, dt: DataTable) {
		this.confirmationService.confirm({
			message: `Are you sure you want to send this user <strong>${user.UserName}</strong> new login details? <br/> This will reset the users password.`,
			header: 'Confirmation',
			icon: 'fa fa-key',
			acceptLabel: "yes",
			rejectLabel: "no",
			accept: () => {
				this.loading = true;
				let model = new ChangePasswordUserModel();
				model.UserId = user.Id;
				this.auth.sendLogin(model).then(
					success => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'success', summary: 'Success', detail: `User login details sent.` });
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					}
				);
			}
		});
	}

	download() {
		window.open(this.auth.apiUrl + "/api/users/csv", "_blank");
	}

	filterBirthdays() {
		this.birthdays = true;
		this.loadUsersLazy(this.rowEvent);
	}

	handleFile(event): void {
		let errorMessage = "";
		if (event.xhr.response !== "") {
			errorMessage = "File processed successfully but not all users where imported please look at failed entries.";

			var blob = new Blob([event.xhr.response], { type: "text/plain;charset=utf-8" });
			saveAs(blob, "Failed.csv");

			this.error = [];
			this.error.push({ severity: 'warn', summary: 'Warning', detail: errorMessage });
		} else {
			errorMessage = "File processed successfully and all users added.";
			this.error = [];
			this.error.push({ severity: 'success', summary: 'Success', detail: errorMessage });
		}

		this.uploading = false;
	}

	handleError(event): void {
		this.uploading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

	verify(user: User) {
		this.confirmationService.confirm({
			message: `Are you sure you want to verify this user?`,
			header: 'Confirmation',
			icon: 'fa fa-check',
			accept: () => {
				this.loading = true;
				this.userService.verifyUser(user.Id).then(
					result => {
						this.loading = false;
						this.loadUsersLazy(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

	unverify(user: User) { 
		this.confirmationService.confirm({
			message: `Are you sure you want to unverify this user?`,
			header: 'Confirmation',
			icon: 'fa fa-check',
			accept: () => {
				this.loading = true;
				this.userService.unverifyUser(user.Id).then(
					result => {
						this.loading = false;
						this.loadUsersLazy(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

	createTeam(user: User) {
		this.confirmationService.confirm({
			message: `Are you sure you want to create a team for this user?.`,
			header: 'Team Confirmation',
			icon: 'fa fa-users',
			acceptLabel: "yes",
			rejectLabel: "no",
			accept: () => {
				this.loading = true;
				let model = new CreateTeamForUserModel();
				model.ownerId = user.Id;
				model.name = "";

				this.teamService.create(model).then(
					success => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'success', summary: 'Success', detail: "Team created" });
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					}
				);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/users/users.component.ts